import WidgetsOne from "@components/footer/elements/widgets/WidgetsOne";

export {WidgetsOne}